import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { SectionHeading } from '../components/SectionHeading';
import { committee } from '../data/committee';
export function Committee() {
  return <div className="w-full bg-club-canvas pb-24" data-id="element-639">
      <PageBanner title="The Committee" eyebrow="Leadership" image="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80" data-id="element-640" />

      <div className="max-w-7xl mx-auto px-4 mt-20" data-id="element-641">
        <SectionHeading title="Club Leadership" eyebrow="Governance" intro="Andhra Social & Cultural Association is governed by a dedicated Committee of elected members who volunteer their time and expertise to ensure the continued excellence and prosperity of the Association." data-id="element-642" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16" data-id="element-643">
          {committee.map(member => <div key={member.id} className="flex flex-col sm:flex-row gap-6 bg-white p-6 border border-club-border rounded-sm" data-id="element-644">
              <div className="w-full sm:w-1/3 aspect-[3/4] overflow-hidden rounded-sm flex-shrink-0" data-id="element-645">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-646" />
              </div>
              <div className="w-full sm:w-2/3 flex flex-col justify-center" data-id="element-647">
                <h3 className="text-2xl mb-1 text-club-green" data-id="element-648">{member.name}</h3>
                <p className="text-sm font-semibold text-club-gold uppercase tracking-wider mb-4" data-id="element-649">
                  {member.role}
                </p>
                <p className="text-club-ink/70 text-sm leading-relaxed" data-id="element-650">
                  {member.bio}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}